module.exports = __webpack_public_path__ + "img/clubcard.0587b184.png";